import { render, staticRenderFns } from "./business-unit-macro.component.vue?vue&type=template&id=0a5288e6&scoped=true&"
import script from "./business-unit-macro.component.vue?vue&type=script&lang=ts&"
export * from "./business-unit-macro.component.vue?vue&type=script&lang=ts&"
import style0 from "./business-unit-macro.component.vue?vue&type=style&index=0&id=0a5288e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5288e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})
